<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>



<div class="panel panel-default" style=" margin:5px;
border:#9b7544 2px solid; padding:5px;     margin-top: 15px;">
 <div class="panel-body">
     <div class="wrapper container">
         <ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

         <div *ngIf="hide == 0">
          <div class="card labelheight" style="border:#9b7544 2px solid;margin-top:50px; height:100px; ">
            <div class="row"    style="margin-top:30px;     padding-left: 35px;">
                <div class="col-sm-12 col-lg-4 col-xl-4 text-left">
                    <label style="color:#9b7544;">
                      Check-in Date: <input type="date" time="false" date="true" min="{{today}}"
                      [(ngModel)]="checkindate" (ngModelChange)="checkMin($event)"></label>
                   </div>
                <div class="col-sm-12 col-lg-4 col-xl-4 text-left" >
                    <label style="color:#9b7544;">Check-Out Date: <input type="date"
                       time="false" date="true" min="{{mincheckoutdate}}"
                      [(ngModel)]="checkoutdate" ></label>
                </div>
                <div class="col-sm-12 col-lg-4 col-xl-4 text-left" >
                   <label style="color:#9b7544;">No of Pets: <input type="number" [(ngModel)]="totalroom" min="1"></label>
                </div>

              </div>
            </div>
              <div class="row" style="margin-top:30px">
                  <div class="col-12 text-center">
                      <button  *ngIf="checkindate &&checkoutdate" class="btn btn-outline-success btn-block" (click)="checkAvailablity()">
                          Proceed </button>
                  </div>

              </div>
            </div>
<mat-horizontal-stepper linear #stepper  *ngIf="hide == 1">
 <!--<mat-step [label]="'Select User'">
   <mat-step-body >
   <div class="row" style="margin-top:20px" *ngIf="!user_id">
     <div class="col-6 text-center">
       <button class="btn btn-outline-info"
       (click)="selectuser()">Select Existing User</button>
     </div>
     <div class="col-6 text-center">
       <button class="btn btn-outline-primary"
      >Create New User</button>
     </div>
   </div>
   <div class="row" style="margin-top:20px" *ngIf="user_id">
       <div class="col text-center" style="color:#9b7544; font-size:20px">
           <p><b>Selected User Detail</b></p>
          </div>
       <div class="col text-center" style="color:#9b7544; font-size:20px">
        <p>Pet Parent name: {{petparent_name}}</p>
       </div>
       <div class="col text-center" style="color:#9b7544; font-size:20px">
           <p>Contact: {{contact}} </p>
         </div>
     </div>
     <div class="row" *ngIf="user_id">
         <div class="col-6 text-left">
             <button class="btn btn-outline-info" (click)="selectuser()">Change User</button>
           </div>
         <div class="col-6 text-right">
           <button class="btn btn-outline-success" (click)="goToNext()">Nest Step</button>
         </div>
       </div>
   </mat-step-body>

 </mat-step> -->
 <!--
<mat-step [label]="'Availablity Checking'">
 <mat-step-body>
   <div class="card" style="border:#9b7544 2px solid;margin-top:50px; height:100px">
     <div class="row"    style="margin-top:30px">
         <div class="col text-center">
             <label style="color:#9b7544;">
               Enter Check In date <input type="date" time="false" date="true" min="{{today}}"
               [(ngModel)]="checkindate" (ngModelChange)="checkMin($event)"></label>
            </div>
         <div class="col text-center" >
             <label style="color:#9b7544;">Enter Check In date <input type="date"
                time="false" date="true" min="{{mincheckoutdate}}"
               [(ngModel)]="checkoutdate" ></label>
         </div>
         <div class="col text-center" >
            <label>No Of Pet <input type="number" [(ngModel)]="totalroom" min="1"></label>
         </div>

       </div>
     </div>
       <div class="row" style="margin-top:30px">
           <div class="col-6 text-right">
               <button  *ngIf="checkindate &&checkoutdate" class="btn btn-outline-success btn-block" (click)="checkAvailablity()">
                   Proceed </button>
           </div>
         <div class="col-6 text-right">

           <button class="btn btn-outline-danger" (click)="goback()">Back to previous step</button>
         </div>
       </div>
 </mat-step-body>
</mat-step > -->


<mat-step >
    <ng-template matStepLabel>Pet Registration with Details</ng-template>
     <div class="row" style="margin-top:50px; " *ngIf="userpets && userpets.length > 0">
       <div class="col-12 text-center">
           <div class="card" style="border:#9b7544 2px solid " >
             <h4><p class="text-center" style="color: #9b7544">Please select {{totalroom}} Pet to proceed</p></h4>
             <div *ngIf="userpets.length>0" style="margin:10px">
               <table class="table table-bordered text-center">
                 <tr *ngFor="let pet of userpets" style="font-size:18px">
                   <td><input type="checkbox"
                   ngModel={{isPetChecked(pet.id)}} (change)='checkPetsInfo($event,pet.id,pet.pet_name)'
                     [disabled]="!isDisable(pet.id) && chckednumber === totalroom"></td>
                   <td style="color: #9b7544" class='text-left'>Name: {{pet.pet_name}}</td>
                   <td style="color: #9b7544">Date Of Birth: {{pet.dob}}</td>
                   <td style="color: #9b7544">Type: {{pet.pet_type}}</td>
                 </tr>

               </table>

             </div>
           </div>
       </div>


     </div>

     <div *ngIf="hidebooking == 0">
        <div class="col-6 text-center" style="margin-top: 20px">
            <div class="card" style="border:#9b7544 2px solid " >
              <p class="text-center" style="color:#9b7544">If you want to book a hut for a new pet, please add details here.
              </p>
              <button class="btn btn-outline-info" style="margin:5px"
              (click)="createUserPet()">Add Pet</button>
            </div>

        </div>
     </div>

  <!--    <div class="row" style="margin:10px">
        <div class="col-6 text-left">
         <button class="btn btn-outline-danger" (click)="gobackToCheckAvailability()">Back</button>
        </div>
        <div class="col-6 text-right">
       <button class="btn btn-outline-success" *ngIf="petdetail.length == totalroom"
        (click)="goToPetInfoStep()"> Go ToNext</button>
         </div>
      </div> -->

      <div class="card" style="margin-top:50px; " >

           <div class="card" style="margin:10px;border:#9b7544 2px solid;" *ngFor="let pet of petdetail; let i = index">
             <div class="card-header" style="background:#9b7544">
                 <label style="color:#fff;font-size: 20px">Enter Details of: {{pet.pet_name}} </label>
             </div>
             <div class="card-content">

                 <div class="row"  style="margin-top:20px;margin-left:5px;margin-bottom: 20px">
                 <div class="col-sm-12 col-lg-6 col-xl-6 text-left" >
                     <label>Neutered Or Spayed:  </label>
                     <select [(ngModel)]="pet.NeuteredOrSpayed">
                       <option value="Yes">Yes</option>
                       <option value="No">No</option>
                       </select>

                 </div>
                 <div class="col-sm-12 col-lg-6 col-xl-6  text-left" >

                     <label>Age (In years):</label>
                     <input type="text" [(ngModel)]="pet.age">
                 </div>
                 </div>
                 <div class="row" style="margin-top:20px;margin-left:5px;margin-bottom: 20px">
                 <div class="col-sm-12 col-lg-6 col-xl-6  text-left" >
                     <label>Nature:</label>
                     <select [(ngModel)]="pet.nature">

                         <option value="social">Social</option>
                         <option value="aggressive">Aggresive</option>
                         </select>

                 </div>
                 <div class="col-sm-12 col-lg-6 col-xl-6  text-left" >

                     <label>Gender:  </label>
                     <select [(ngModel)]="pet.gender">
                         <option value="m">Male</option>
                         <option value="f">Female</option>
                         </select>

                 </div>
              </div>
             </div>
           </div>
         <div class="row" style="margin-top:30px; margin-bottom:10px; margin-right: 5px">

             <div style="margin-top: 20px" class="col-sm-12 col-lg-6 col-xl-6 text-center" *ngIf="petdetail.length == totalroom">
                 <button  class="btn btn-outline-success btn-block" (click)="bookRoom(stepper)">Submit</button>
               </div>
             <div style="margin-top: 20px" class="col-sm-12 col-lg-6 col-xl-6 text-center">
               <button class="btn btn-outline-danger" (click)="gobackToCheckAvailability()">Back to previous step</button>
             </div>
         </div>
     </div>
 </mat-step >


<!-- <mat-step [label]="'Add pet info'">
   <mat-step-body>

   </mat-step-body>
 </mat-step > -->

 <mat-step  >
  <ng-template matStepLabel>Food Detail</ng-template>
      <div class="col-12 text-center" style="margin:10px">
        <h4><p>Select Food For Your Beloved</p></h4>
      </div>
      <div class="card" style="border:#9b7544 2px solid; margin-top: 10px "
      *ngIf="petdetail.length == totalroom">
        <p class="text-center" style="color:#9b7544">Would You Like to handover food during Checkin/Pick Up</p>
        <mat-radio-group>
            <mat-radio-button class="text-center" style="margin-left: 31%" *ngFor="let ar of  foodchoicearray" [value]="ar"
                         (change)="radioChangeForFoodOption($event,ar, stepper)">
                {{ar}}
            </mat-radio-button>

        </mat-radio-group>
        <p class="text-center" style="color:#9b7544" *ngIf="foodchoice=='yes'">** We Accept Only Seal pack food
        </p>
      </div>
      <div *ngIf="foodchoice === 'no'">
           <div class="card" *ngFor="let pet of petdetail"
           style="margin:10px;border:#9b7544 2px solid;">
               <div class="card-header" style="background:#9b7544" *ngIf="foodchoice ==='no'">
                   <label style="color:#fff;font-size: 20px">Pet Name: {{pet.pet_name}} </label>
               </div>
               <div class="card-content">
             <div class="row" *ngIf="foodchoice=='no'">
               <div class="col-sm-12 col-lg-4 col-xl-4 text-center">
                 <label>Food preference: </label>
                     <mat-radio-group>
                       <div  *ngFor="let ser of  nestservice">
                         <div *ngIf="ser.type_id == 2 && ser.id == 4"
                                      (change)="ChangeFoodPreference($event,ser,pet.pet_id)">
                            <h2> {{ser.name}} </h2>
                       </div>
                       </div>
                     </mat-radio-group>
               </div>
               <!--<div class="col-sm-12 col-lg-4 col-xl-4 text-center" *ngIf="pet.food_preferenceid && pet.food_preferenceid == 3">
                <div class="form-group">
                 <label>Cooked Food Type: </label>
                   <mat-radio-group>
                     <div  *ngFor="let ser of  nestservice">
                       <mat-radio-button *ngIf="ser.type_id == pet.food_preferenceid " [value]="ser.id"
                       (change)="addCookedfood($event,ser,pet.pet_id)">
                           {{ser.name}}
                       </mat-radio-button>
                     </div>
                   </mat-radio-group>
                 </div>
               </div>
               <div class="col-sm-12 col-lg-4 col-xl-4  text-center" *ngIf="pet.food_preferenceid && pet.food_preferenceid == 3">
                   <table class="table table-bordered text-center" *ngIf="isCookfoodtypeselected(pet.pet_id)">
                     <thead>
                      <th>Total Days</th>
                      <th>Fees</th>
                      <th>Total Payable</th>
                     </thead>
                     <tbody *ngFor="let x of cookedfoodservice; let i = index">
                       <tr *ngIf="x.pet_id==pet.pet_id">
                         <td>{{totaldays}}</td>
                         <td>{{x.fees}}</td>
                         <td>{{x.payable}}</td>
                       </tr>
                     </tbody>
                   </table>
               </div> -->
               <div class="col-sm-12 col-lg-8 col-xl-8  text-center" >
                 <div class="form-group" *ngIf="!ispackageFoodalreadyAdded(pet.pet_id)">
                 <label>Add packaged Food </label>
                   <button class="btn btn-outline-success" style="margin-top:10px"
                   (click)="buyFoodFrompetcart(pet.pet_id)">Buy From Petcart</button>
                 </div>
                 <table class="table table-bordered text-center" *ngIf="ispackageFoodalreadyAdded(pet.pet_id)">
                   <thead>
                     <th>Product Name</th>
                     <th>Qty</th>
                     <th>Fees</th>
                     <th>Manage</th>
                   </thead>
                   <tbody *ngFor="let x of packagedfoodservice; let i = index">
                   <tr *ngIf="x.pet_id==pet.pet_id">
                     <td>{{x.name}}</td>
                     <td >
                         <button style="background-color:transparent;" *ngIf="x.qty>1"
                         (click)="subQty(i)"><mat-icon style="color:#9b7544">remove_circle_outline</mat-icon></button>
                         <span style="color:#9b7544">{{x.qty}}</span>
                    <button style="background-color:transparent;"  (click)="addQty(i)"  >
                      <mat-icon style="color:#9b7544">add_circle</mat-icon></button>
                     </td>
                     <td>{{x.payable}}</td>
                     <td><button class="btn btn-danger btn-sm" (click)="removeparticularpackageFood(i)">
                       Remove</button>
                      </td>
                   </tr>
                   </tbody>
                 </table>
                 <div class="col-12 "style="margin:10px" *ngIf="ispackageFoodalreadyAdded(pet.pet_id)">
                     <button class="btn btn-success btn-sm taxt-right" (click)="buyFoodFrompetcart(pet.pet_id)">
                         Add another</button>
                 </div>
               </div>
             </div>

            <!-- <div class="row" *ngIf="foodchoice=='yes'" style="margin:10px">
               <div class="col-12 text-center" >
                 <h5><p>We Only Accept Sealed packaged Food and detail should be submitted at the time of check in</p></h5>
               </div>
             </div>-->

           </div>
           </div>
          </div>
       <div class="row" style="margin-top:30px; margin-bottom:10px; margin-right: 5px">

             <div class="col-sm-12 col-lg-6 col-xl-6 text-center" style="margin-top:10px" >
                 <button class="btn btn-outline-success btn-block"
                  (click)="radioChangeForPickAndDrop(stepper)">Go To next step</button>
               </div>
             <div class="col-sm-12 col-lg-6 col-xl-6 text-center" style="margin-top:10px">
               <button class="btn btn-outline-danger" (click)="goback1(stepper)">Back to previous step</button>
             </div>
         </div>
     
 </mat-step>
 <!--
 <mat-step [label]="'Pick And Drop'" >
     <mat-step-body>
         <div class="card" style="margin:10px; ">
            <div class="col-6 text-center">
                <div class="card" style="border:#9b7544 2px solid; margin-top: 10px "
                >
                <div class="form-group">


                  <p class="text-center" style="color:#9b7544">Would You Like To Take PetCart Pick And Drop facility</p>
                  <mat-radio-group>
                      <mat-radio-button *ngFor="let ar of  foodchoicearray" [value]="ar"
                                   (change)="radioChangeForPickAndDrop($event,ar)">
                          {{ar}}
                      </mat-radio-button>

                  </mat-radio-group>
                </div>
                </div>
            </div>
             <div class="row" *ngIf="pickanddrop=='no'" style="margin:10px">
                 <div class="col-12 text-center" >
                   <h5><p></p></h5>
                 </div>
               </div>

               <div  *ngIf="pickanddrop=='yes'" style="margin:10px" >

                     <div class="col-12 text-center" *ngFor="let ser of nestservice"  >
                       <h4 *ngIf="ser.type_id==10" style="color:#9b7544">
                         <input type="checkbox" name="pickupanddrop"  (change)="addingpickanddrop($event,ser)"
                          checked>{{ser.name}}</h4>
                     </div>

                  <div class="row" *ngIf="pickanddropservice.length>0">
                    <div class="col-5 text-center">

                        <div  *ngIf="pickup=='yes'">
                            <p class="text-center">Please Select Pick Up Time on {{checkindate}}</p>
                            <mat-radio-group>
                                <mat-radio-button *ngFor="let ti of  timing"   [value]="ti"
                                [(ngModel)]="pickuptime"    (change)="radioChangeForPickUpTime($event,ti)"
                                ngDefaultControl>
                                    {{ti}}
                                </mat-radio-button>

                            </mat-radio-group>
                          </div>
                    </div>
                    <div class="col-2 text-center"> </div>
                    <div class="col-5 text-center">
                          <div  *ngIf="drop=='yes'">
                              <p class="text-center">Please Select Drop Time on {{checkoutdate}}</p>
                              <mat-radio-group>
                                  <mat-radio-button *ngFor="let ti of  timing"  [value]="ti"
                                          [(ngModel)]="droptime" (change)="radioChangeForDropTime($event,ti)"
                                          ngDefaultControl>
                                      {{ti}}
                                  </mat-radio-button>

                              </mat-radio-group>
                          </div>
                        </div>


                  </div>

                  <div class="row" *ngIf="pickanddropservice.length>0">
                    <div class="col-12 text-center">
                      <div class="form-group"  *ngIf="drop=='yes' || pickup=='yes'">
                          <label  style="color:#9b7544; font-size: 18px">Enter Address </label>
                          <textarea rows="6" cols="80" [(ngModel)]="address"></textarea>
                        </div>


                   </div>
                  </div>
                 </div>
                 <div class="row" style="margin-top:30px; margin-bottom:10px; margin-right: 5px">
                     <div class="col-4">

                     </div>
                       <div class="col-4" *ngIf="pickanddrop">
                           <button class="btn btn-outline-success btn-block"
                            (click)="goToSummery()">Go To next step</button>
                         </div>
                       <div class="col-4 text-right">
                         <button class="btn btn-outline-danger" (click)="goback()">Back to previous step</button>
                       </div>
                   </div>

         </div>
         </mat-step-body>
       </mat-step>
      -->

 <mat-step>
  <ng-template matStepLabel>Services</ng-template>
       <div class="card" style="margin:10px; ">
           <div class="row"    style="margin-top:30px;">
           <div class="col-11 text-center" style="border:#9b7544 2px solid; margin:0px 0px 0px 15px;">
             <div class="row" style="color: #9b7544">
               <div class="col text-center">
                 <label>Check-in:<br> {{checkindate}}</label>
               </div>
               <div class="col text-center">
                   <label>Check-Out:<br> {{checkoutdate}}</label>
                 </div>
                 <div class="col text-center">
               <label>Number of Days: {{totaldays}}</label>
               </div>
               <div class="col text-center">
               <label>Number of Rooms: {{totalroom}}</label>
               </div>
             </div>
             <div class="row">
               <div class="col-12">
            <h4> <p class="text-center">Booking Summary</p></h4>
             <table class="table table-bordered">
                 <thead style="color: #9b7544;     text-align: center;" >
                   <th>Name</th>
                   <th>Tariff</th>
                   <th>Days/Qty</th>
                   <th>Payable</th>

                 </thead>
                 <tbody *ngFor="let serv of availservice">
                   <tr >
                     <td>
                       {{serv.name}}
                     </td>
                     <td>
                         {{serv.fees}}
                       </td>
                       <td *ngIf="serv.service_id == 1">
                           {{serv.days}}*{{totalroom}}
                       </td>
                       <td *ngIf="serv.service_id !== 1">
                           {{serv.days}}
                       </td>
                       <td>
                           {{serv.payable}}
                         </td>

                   </tr>
                 </tbody>
               <!--  <tr *ngIf="addedservice.length>0">
                   <td style="color:#9b7544; font-size:20px">Added Services</td>
                   <td></td>
                    <td></td>
                   <td></td>
                   <td></td>
                 </tr> -->
                 <tr *ngFor="let s of  addedservice; let i = index">
                     <td>
                         {{s.name}}
                       </td>
                       <td>
                           {{s.fees}}
                         </td>
                         {{s.days}}
                         <td>
                             {{s.payable}}
                           </td>

                 </tr>
                 <tr>
                     <td>Total</td>
                 <td><!--Give Discount<input type="number" [(ngModel)]="discountper"
                       (ngModelChange)="calculateFees()" >% --></td>
                     <td>Total Discount: {{discount}}</td>
                     <td>Total payable: {{totalpayable}}</td>
                     <td></td>
                   </tr>
               </table>

             </div>
           </div>
           <div>
              <mat-card-content>
                <div *ngIf="coupon !== 1" >
                  <label style="margin-top: 39px; margin-right: 0%; color: #9b7544" *ngIf="coupon !== 1" >Have a Coupon</label>
                  <input [(ngModel)]="couponcode" type="text"/>
                  <button class="btn btn-success" (click)="addCoupon()">Apply </button>
                </div>
                  <div class="row" *ngIf="coupon == 1">
                    <div class="col-9 text-center">
                        <h3 style="color:#9b7544">Applied Coupon Code <a style="color: green"> {{couponcode}} </a> </h3>
                    </div>
                    <div class="col-3 text-center">
                        <button *ngIf="couponcode!== 'NEST33OFF'" class="btn btn-link" style="color: red"  (click)="removeCouponCode()">
                            Remove  </button>
                      </div>
                  </div>
                </mat-card-content>
           </div>
           <div  style="font-size:15px">
            <div class="form-check" style="margin-top: 21px; margin-bottom: 23px;" >
                <a style="font-size: 20px ; color: #9b7544" ><b>Disclaimer</b></a>
                <label style="color:#9b7544"class="form-check-label">
                  <input class="form-check-input" type="checkbox"  (change)="checked2($event)"   required>
                 <a style="font-size: 16px; color: #9b7544"> I agree to the Terms and Conditions set by PETCART (Blends Pet Solutions Pvt Ltd) for Boarding and related services</a></label>

              </div>
        </div>

           <div class="row" style="margin:5px" >

             <div class="col-sm-12 col-lg-6 col-xl-6 text-center" style="margin-top: 10px">
               <button class="btn btn-outline-info btn-block"
               (click)="openEmergencyPage(stepper)">Book</button>
             </div>
             <div class="col-sm-12 col-lg-6 col-xl-6 text-center" style="margin-top: 10px">
                <button class="btn btn-outline-danger" (click)="goback2(stepper)">Back to previous step</button>
             </div>
           </div>

           </div>

        <!--   <div class="col-4" style="margin:10px">
             <div class="card" style="border:#9b7544 2px solid;">
              <h4 style="color: #9b7544"><p class="text-center"> Other Paid Service</p></h4>
               <table class="table table-bordered">
                 <thead style="color: #9b7544">
                   <th>Name</th>
                   <th>Fees</th>
                   <th>Manage</th>
                 </thead>
                 <tbody *ngFor="let serv of nestservice">
                   <tr  *ngIf="serv.type_id==9">
                     <td>
                       {{serv.name}}
                     </td>
                     <td>
                         {{serv.fees}}
                       </td>
                     <td *ngIf="isAvail(serv.id)" style="color:#9b7544">Already Add</td>
                       <td>
                           <button class="btn btn-link" *ngIf="!isAvail(serv.id)"
                           (click)="addService(serv.id,serv.name,serv.fees)">Add</button>
                         </td>
                   </tr>
                 </tbody>
               </table>
             </div>
            <!-- <div class="card" style="border:#9b7544 2px solid;margin-top:15px">
               <div class="form-group">
                 <label>
                   Alternet Contact Number(** this field Is mandetory)
                   <input type="number" [(ngModel)]="alternetcontact">
                 </label>
               </div>
               <div class="form-group">
                   <label>
                     Vet Name(Emergency case)
                     <input type="text" [(ngModel)]="vetname">
                   </label>
                 </div>
                 <div class="form-group">
                     <label>
                       Vet Contact(Emergency case)
                       <input type="text" [(ngModel)]="vetcontact">
                     </label>
                   </div>
             </div>
           </div>-->
           </div>

       </div>
   
 </mat-step>
 <mat-step>
  <ng-template matStepLabel>Confirmation</ng-template>
         <div class="row">
             <div class="col-12 text-center">
               <p style="color:#9b7544; overflow-wrap:break-word; font-style:open sans;
               font-size:20px">
               Nest Booked Successfully  <mat-icon>done all</mat-icon>
             </p>
             </div>
             <div class="col-12 text-center">
              <!-- <button class="btn btn-success"  >Manage Booking</button> -->
             </div>
           </div>
     </mat-step>
</mat-horizontal-stepper>
</div>
</div>
</div>
